import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Home, Search, HelpCircle } from 'lucide-react';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-teal-100">
      <SEO 
        title="Page Not Found"
        description="The page you're looking for doesn't exist. But don't worry, you can find what you need using our helpful resources."
      />
      
      <div className="max-w-2xl mx-auto px-4 py-16 sm:px-6 sm:py-24">
        <div className="text-center">
          <p className="text-base font-semibold text-teal-600">404</p>
          <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900">Page not found</h1>
          <p className="mt-4 text-base text-gray-500">
            Sorry, we couldn't find the page you're looking for.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2">
          <Link
            to="/"
            className="relative block rounded-lg border border-gray-200 p-6 hover:border-teal-500 hover:ring-1 hover:ring-teal-500 transition-all"
          >
            <div className="flex items-center gap-4">
              <Home className="h-6 w-6 text-teal-600" />
              <div className="text-left">
                <h3 className="font-semibold text-gray-900">Go home</h3>
                <p className="mt-1 text-sm text-gray-500">
                  Return to our homepage
                </p>
              </div>
            </div>
          </Link>

          <Link
            to="/resume"
            className="relative block rounded-lg border border-gray-200 p-6 hover:border-teal-500 hover:ring-1 hover:ring-teal-500 transition-all"
          >
            <div className="flex items-center gap-4">
              <FileText className="h-6 w-6 text-teal-600" />
              <div className="text-left">
                <h3 className="font-semibold text-gray-900">Create resume</h3>
                <p className="mt-1 text-sm text-gray-500">
                  Start building your professional resume
                </p>
              </div>
            </div>
          </Link>

          <Link
            to="/help"
            className="relative block rounded-lg border border-gray-200 p-6 hover:border-teal-500 hover:ring-1 hover:ring-teal-500 transition-all"
          >
            <div className="flex items-center gap-4">
              <HelpCircle className="h-6 w-6 text-teal-600" />
              <div className="text-left">
                <h3 className="font-semibold text-gray-900">Get help</h3>
                <p className="mt-1 text-sm text-gray-500">
                  Visit our help center
                </p>
              </div>
            </div>
          </Link>

          <Link
            to="/faq"
            className="relative block rounded-lg border border-gray-200 p-6 hover:border-teal-500 hover:ring-1 hover:ring-teal-500 transition-all"
          >
            <div className="flex items-center gap-4">
              <Search className="h-6 w-6 text-teal-600" />
              <div className="text-left">
                <h3 className="font-semibold text-gray-900">FAQ</h3>
                <p className="mt-1 text-sm text-gray-500">
                  Browse frequently asked questions
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}